export default __webpack_public_path__ + "static/media/evan.71d657f4.jpg";